import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './BottomToast.scss';


const propTypes = {
  children: PropTypes.node.isRequired,
  isVisible: PropTypes.bool.isRequired,
};


const BottomToast = ({ children, isVisible }) => {
  const bottomToastClasses = classNames({
    'bottom-toast-wrapper': true,
    'show-bottom-toast': isVisible,
  });
  return (
    <div className={bottomToastClasses}>
      <div className="content">
        {children}
      </div>
    </div>
  );
};


BottomToast.propTypes = propTypes;


export default BottomToast;



// WEBPACK FOOTER //
// ./src/components/_molecules/BottomToast/BottomToast.js